import * as React from 'react';

const CloseCircleOutlineIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5292 1.99951C7.00674 1.99951 2.52991 6.47635 2.52991 11.9988C2.52991 17.5213 7.00674 21.9981 12.5292 21.9981C18.0517 21.9981 22.5285 17.5213 22.5285 11.9988C22.5285 6.47635 18.0517 1.99951 12.5292 1.99951ZM0.529907 11.9988C0.529907 5.37178 5.90217 -0.000488281 12.5292 -0.000488281C19.1562 -0.000488281 24.5285 5.37178 24.5285 11.9988C24.5285 18.6258 19.1562 23.9981 12.5292 23.9981C5.90217 23.9981 0.529907 18.6258 0.529907 11.9988ZM16.9029 7.62593C17.2934 8.01646 17.2934 8.64962 16.9029 9.04014L13.9436 11.9995L16.9029 14.9588C17.2934 15.3493 17.2934 15.9825 16.9029 16.373C16.5124 16.7635 15.8792 16.7635 15.4887 16.373L12.5294 13.4137L9.57005 16.373C9.17953 16.7635 8.54636 16.7635 8.15584 16.373C7.76531 15.9825 7.76531 15.3493 8.15584 14.9588L11.1152 11.9995L8.15584 9.04014C7.76531 8.64962 7.76531 8.01646 8.15584 7.62593C8.54636 7.23541 9.17953 7.23541 9.57005 7.62593L12.5294 10.5853L15.4887 7.62593C15.8792 7.23541 16.5124 7.23541 16.9029 7.62593Z"
      fill="white"
    />
  </svg>
);

export default CloseCircleOutlineIcon;
